var keys = {
    TOS_acceptAndClose: "TOS_acceptAndClose",
    TOS_failedToLoad: "TOS_failedToLoad",
    TOS_unavailableTitle: "TOS_unavailableTitle",
    TOS_unavailableDescription: "TOS_unavailableDescription",
    TOS_unavailableRetry: "TOS_unavailableRetry",
    TOS_importantUpdate: "TOS_importantUpdate",
    TOS_changeOfTos: "TOS_changeOfTos",
    TOS_acceptedTos: "TOS_acceptedTos",
    TOS_tos_acceptance: "TOS_tos_acceptance",
    TOS_user_id: "TOS_user_id",
    TOS_entity_id: "TOS_entity_id",
    TOS_acceptance_date: "TOS_acceptance_date",
    TOS_tos_name: "TOS_tos_name",
    TOS_revision: "TOS_revision",
    TOS_tos_details: "TOS_tos_details",
    TOS_user_details: "TOS_user_details",
    TOS_email: "TOS_email",
    TOS_enableMMLite: "TOS_enableMMLite",
    TOS_improvePerfDescription: "TOS_improvePerfDescription",
    TOS_acceptMMLiteTerms: "TOS_acceptMMLiteTerms",
    TOS_betterDeliveryRates: "TOS_betterDeliveryRates",
    TOS_noIntegrationEffort: "TOS_noIntegrationEffort",
    TOS_exclusiveMarketingFeatures: "TOS_exclusiveMarketingFeatures",
    TOS_proceedWithBusinessPortfolio: "TOS_proceedWithBusinessPortfolio",
    TOS_selectBusinessPortfolio: "TOS_selectBusinessPortfolio",
    TOS_connecting: "TOS_connecting",
    TOS_continueWithFacebook: "TOS_continueWithFacebook",
    TOS_agreeToConnect: "TOS_agreeToConnect",
    TOS_needHelp: "TOS_needHelp",
    TOS_termsAccepted: "TOS_termsAccepted",
    TOS_closeWindow: "TOS_closeWindow",
    TOS_continueToHub: "TOS_continueToHub",
    TOS_backToHub: "TOS_backToHub",
    TOS_mmLiteEnabled: "TOS_mmLiteEnabled",
    TOS_close: "TOS_close",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ3BDLGtCQUFrQixFQUFFLG9CQUFvQjtJQUN4QyxnQkFBZ0IsRUFBRSxrQkFBa0I7SUFDcEMsb0JBQW9CLEVBQUUsc0JBQXNCO0lBQzVDLDBCQUEwQixFQUFFLDRCQUE0QjtJQUN4RCxvQkFBb0IsRUFBRSxzQkFBc0I7SUFDNUMsbUJBQW1CLEVBQUUscUJBQXFCO0lBQzFDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxrQkFBa0IsRUFBRSxvQkFBb0I7SUFDeEMsV0FBVyxFQUFFLGFBQWE7SUFDMUIsYUFBYSxFQUFFLGVBQWU7SUFDOUIsbUJBQW1CLEVBQUUscUJBQXFCO0lBQzFDLFlBQVksRUFBRSxjQUFjO0lBQzVCLFlBQVksRUFBRSxjQUFjO0lBQzVCLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLFNBQVMsRUFBRSxXQUFXO0lBQ3RCLGdCQUFnQixFQUFFLGtCQUFrQjtJQUNwQywwQkFBMEIsRUFBRSw0QkFBNEI7SUFDeEQscUJBQXFCLEVBQUUsdUJBQXVCO0lBQzlDLHVCQUF1QixFQUFFLHlCQUF5QjtJQUNsRCx1QkFBdUIsRUFBRSx5QkFBeUI7SUFDbEQsOEJBQThCLEVBQUUsZ0NBQWdDO0lBQ2hFLGdDQUFnQyxFQUFFLGtDQUFrQztJQUNwRSwyQkFBMkIsRUFBRSw2QkFBNkI7SUFDMUQsY0FBYyxFQUFFLGdCQUFnQjtJQUNoQyx3QkFBd0IsRUFBRSwwQkFBMEI7SUFDcEQsa0JBQWtCLEVBQUUsb0JBQW9CO0lBQ3hDLFlBQVksRUFBRSxjQUFjO0lBQzVCLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxlQUFlLEVBQUUsaUJBQWlCO0lBQ2xDLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxhQUFhLEVBQUUsZUFBZTtJQUM5QixpQkFBaUIsRUFBRSxtQkFBbUI7SUFDdEMsU0FBUyxFQUFFLFdBQVc7Q0FDdkIsQ0FBQztBQUVGLGVBQWUsSUFBSSxDQUFDIn0=